module.exports = __webpack_public_path__ + "static/img/login.f7cc2e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/login.png
// module id = OdF4
// module chunks = 48